import { render, staticRenderFns } from "./FreeTalkStart.vue?vue&type=template&id=6f5f15b6&scoped=true&"
import script from "./FreeTalkStart.vue?vue&type=script&lang=js&"
export * from "./FreeTalkStart.vue?vue&type=script&lang=js&"
import style0 from "./FreeTalkStart.vue?vue&type=style&index=0&id=6f5f15b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5f15b6",
  null
  
)

export default component.exports